<template>
  <div class="admin_root">
    <div>
      <router-link :to="`/admin/towers`">Edit Tower Data</router-link>
    </div>
    <div>
      <router-link :to="`/admin/legacies`">Edit Legacies Data</router-link>
    </div>
  </div>
</template>

<script src="./admin.js">
</script>

<style lang="scss">
</style>
